/*******************************  NOTY  ********************************/

var noty_error = function (message, time, show_callback, close_callback) {
  time = parseInt(time);
  if (isNaN(time) || !time) time = 5000;
  new Noty({
    type: 'error',
    layout: 'topRight',
    theme: 'bootstrap-v3',
    timeout: time,
    text: message,
    callbacks: {
      onShow: function () {
        if (typeof show_callback == 'function') show_callback();
      },
      onClose: function () {
        if (typeof close_callback == 'function') close_callback();
      },
    },
  }).show();
};

var noty_warning = function (message, time, show_callback, close_callback) {
  time = parseInt(time);
  if (isNaN(time) || !time) time = 5000;
  new Noty({
    type: 'warning',
    layout: 'topRight',
    theme: 'bootstrap-v3',
    timeout: time,
    text: message,
    callbacks: {
      onShow: function () {
        if (typeof show_callback == 'function') show_callback();
      },
      onClose: function () {
        if (typeof close_callback == 'function') close_callback();
      },
    },
  }).show();
};

var noty_success = function (message, time, show_callback, close_callback) {
  time = parseInt(time);
  if (isNaN(time) || !time) time = 5000;
  new Noty({
    type: 'success',
    layout: 'topRight',
    theme: 'bootstrap-v3',
    timeout: time,
    text: message,
    callbacks: {
      onShow: function () {
        if (typeof show_callback == 'function') show_callback();
      },
      onClose: function () {
        if (typeof close_callback == 'function') close_callback();
      },
    },
  }).show();
};

var noty_info = function (message, time, show_callback, close_callback) {
  time = parseInt(time);
  if (isNaN(time) || !time) time = 5000;
  new Noty({
    type: 'info',
    layout: 'topRight',
    theme: 'bootstrap-v3',
    timeout: time,
    text: message,
    callbacks: {
      onShow: function () {
        if (typeof show_callback == 'function') show_callback();
      },
      onClose: function () {
        if (typeof close_callback == 'function') close_callback();
      },
    },
  }).show();
};

/**
 * Genera un alert che chiede la conferma per l'azione. E' possibile passare un URL o una callback
 *
 * @param {string} confirm_text
 * @param {string} yes_button
 * @param {string} no_button
 * @param {string|function} action
 * @param {function} cancel_action
 * @returns {boolean}
 */
var noty_confirm = function (confirm_text, yes_button, no_button, action, cancel_action) {

  confirm_text = confirm_text || 'Sei sicuro di voler proseguire?';
  yes_button = yes_button || 'Si';
  no_button = no_button || 'No';

  if (typeof action === 'undefined') return false;

  var n = new Noty({
    text: confirm_text,
    layout: 'center',
    modal: true,
    buttons: [
      Noty.button(yes_button, 'btn btn-success float-right', function () {
        if (typeof action === 'function') {
          action();
        } else {
          window.location.href = action;
        }
        n.close();
      }, {id: 'button1', 'data-status': 'ok'}),
      Noty.button(no_button, 'btn btn-danger', function () {
        if (typeof cancel_action === 'function') {
          cancel_action();
        } else if (typeof cancel_action !== 'undefined') {
          window.location.href = cancel_action;
        }
        n.close();
      })
    ]
  }).show();

};

/*******************************  /NOTY  ********************************/

$(document).ready(function () {

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  /*******************************  FILTER COLLAPSE  ********************************/

  $(document).on('click', '[data-target=".filter-collapse"]', function (event) {
    var expanded = $(this).attr('aria-expanded');
    if (expanded == 'true') {
      $(this).html('<i class="fas fa-minus"></i> Mostra meno filtri');
    } else {
      $(this).html('<i class="fas fa-plus"></i> Mostra più filtri');
    }
  });

  /*******************************  /FILTER COLLAPSE  ********************************/

  /*******************************  COLLAPSE ARROW  ********************************/

  $(document).on('click', '[data-toggle="collapse"]', function (event) {
    var $i = $(this).find('i[class*="fa-angle"]');
    $i.toggleClass('fa-angle-up fa-angle-down');
  });

  /*******************************  /COLLAPSE ARROW  ********************************/

  /*******************************  TABLE FIXED HEADER  ********************************/

  if ($('.table_fixed_header').length) {
    for (var i = 0; i < $('.table_fixed_header').length; i++) {
      apply_table_fixed_header($('.table_fixed_header').eq(i));
    }
  }

  $(window).on('resize', function (event) {
    resize_fixed_table_header();
  });

  /*******************************  /TABLE FIXED HEADER  ********************************/

  /*******************************  ALWAYS SCROLLABLE TABLE  ********************************/

  if ($('.table_always_scrollable').length) {
    for (var i = 0; i < $('.table_always_scrollable').length; i++) {
      top_bottom_scroll_bar($('.table_always_scrollable').eq(i));
    }
  }

  /*******************************  /ALWAYS SCROLLABLE TABLE  ********************************/

  /*******************************  BOOTSTRAP SUBMENU  ********************************/

  $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
    }
    var $subMenu = $(this).next(".dropdown-menu");
    $subMenu.toggleClass('show');

    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
      $('.dropdown-submenu .show').removeClass("show");
    });

    return false;
  });

  /*******************************  /BOOTSTRAP SUBMENU  ********************************/

  /*******************************  FORM CHECKER  ********************************/

  $('.required_check').on('submit', function (event) {

    var errors = [];
    var requireds = $(this).find('.required');

    for (var i = 0; i < requireds.length; i++) {
      var required_element = requireds.eq(i);
      if (requireds.eq(i).val() == '') {
        field_label = $('label[for=' + required_element.attr('id') + ']').clone();
        field_label.find('span, small').remove();
        field_label = field_label.text();
        field_label = field_label.replace(':', '');
        if ($.trim(required_element.val()) == '' || $.trim(required_element.val()) == 'NULL') {
          errors.push('Il campo <strong>' + field_label + '</strong> è obbligatorio.');
          required_element.focus();
        }
      }
    }

    if (errors.length > 0) {
      text = '';
      for (i = 0; i < errors.length; i++) {
        text += '<p>' + errors[i] + '</p>';
      }
      noty_warning(text);
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  });

  /*******************************  /FORM CHECKER  ********************************/

  /*******************************  AJAX FORM  ********************************/

  $(document).on('submit', '.ajax_form', function (event) {

    var $form = $(this);
    var $btn = $form.find('[type="submit"], .ajax_form_btn_salva_e_continua, .ajax_form_btn_salva_e_chiudi');
    $btn.prop('disabled', true);

    var action = $form.attr('action');
    var data = $form.serializeArray();
    var success_msg = $form.attr('data-success_msg');
    var page_reload = parseInt($form.attr('data-page_reload'));
    var file_upload = $form.attr('data-file_upload');
    var redirect_to = $form.attr('data-redirect_to');
    var success_callback = $form.attr('data-success_callback');
    var confirm = $form.attr('data-confirm');
    var confirm_msg = $form.attr('data-confirm_msg');
    var display_log = $form.attr('data-display_log');
    var log_container = $form.attr('data-log_container');
    var close_modal = $form.attr('data-close_modal');
    var ajax_options = {};

    var waiting_noty = new Noty({
      type: 'info',
      layout: 'topRight',
      theme: 'bootstrap-v3',
      timeout: 300000,
      text: 'Attendere prego',
    }).show();

    if (!success_msg || typeof success_msg == 'undefined') success_msg = 'Operazione conclusa con successo';
    if (!redirect_to || typeof redirect_to == 'undefined') redirect_to = false;
    if (!success_callback || typeof success_callback == 'undefined') success_callback = false;
    if (!confirm || typeof confirm == 'undefined') confirm = false;
    if (!confirm_msg || typeof confirm_msg == 'undefined') confirm_msg = 'Sei sicuro di voler procedere?';
    if (!display_log || typeof display_log == 'undefined') display_log = false;
    if (!log_container || typeof log_container == 'undefined') log_container = '';
    if (!close_modal || typeof close_modal == 'undefined') close_modal = false;

    if (isNaN(page_reload)) page_reload = 0;
    file_upload = file_upload || false;

    event.preventDefault();

    if (file_upload) {
      var data = new FormData($form[0]);
      ajax_options = {
        url: action,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
        dataType: 'JSON',
        data: data,
      };
    } else {
      ajax_options = {
        url: action,
        type: 'POST',
        dataType: 'JSON',
        data: data,
      };
    }

    var ajax_function = function () {
      $.ajax(ajax_options)
        .done(function (response) {
          if (response.message == 'OK') {
            noty_success(success_msg);
            if (success_callback && typeof window[success_callback] === 'function') {
              window[success_callback].call();
            } else if (redirect_to) {
              window.location.replace(redirect_to);
            } else if (page_reload == 1) {
              window.location.reload();
            }

            //TODO DA PERFEZIONARE ED INTRODURRE NEGLI ALTRI PORTALI DOVE PRESENTE AJAX_FORM
            $form.find('.ajax_form_reset_field').each(function () {
              $(this).val('');
              if ($(this).hasClass('enhanced_select')) {
                $(this).multiselect('deselectAll', false).multiselect('refresh');
              }
            });

          } else {
            if (display_log) {
              $(log_container).html('');
              var html = $(log_container).html(response.message).text();
              $(log_container).html(html);
            } else {
              noty_warning(response.message);
            }
          }
          if (close_modal) $('.modal').modal('hide');
        })
        .fail(function (data) {
          gestione_errore_ajax(data);
        })
        .always(function () {
          waiting_noty.close();
          $btn.prop('disabled', false);
        });
    }

    if (confirm) {
      noty_confirm(confirm_msg, 'Sì', 'No', ajax_function);
    } else {
      ajax_function();
    }

  });

  $(document).on('click', '.ajax_form_btn_salva_e_continua', function (event) {
    var $form = $(this).closest('.ajax_form');
    event.preventDefault();
    $form.attr('data-page_reload', 0);
    $form.submit();
  });

  $(document).on('click', '.ajax_form_btn_salva_e_chiudi', function (event) {
    var $form = $(this).closest('.ajax_form');
    event.preventDefault();
    $form.attr('data-page_reload', 1);
    $form.submit();
  });

  /*******************************  /AJAX FORM  ********************************/

  /*******************************  FORM WAIT FOR LOADING  ********************************/

  $(document).on('submit', '.form_wait_for_loading', function (event) {
    var waiting_noty = new Noty({
      type: 'info',
      layout: 'topRight',
      theme: 'bootstrap-v3',
      timeout: 300000,
      text: 'Attendere prego',
    }).show();
  });

  /*******************************  /FORM WAIT FOR LOADING  ********************************/

  /*******************************  WAITING FOR DOWNLOAD  ********************************/

  $(document).on('submit', '.form_waiting_download', function (event) {

    var message = $(this).attr('data-message');
    var timeout = parseInt($(this).attr('data-waiting_timeout'));

    if (!message || typeof message == 'undefined') message = 'Attendere prego, il download potrebbe impiegare qualche istante';
    if (!timeout || isNaN(timeout)) timeout = 3000;

    new Noty({
      type: 'info',
      layout: 'topRight',
      theme: 'bootstrap-v3',
      timeout: 3000,
      text: message,
    }).show();
  });

  /*******************************  /WAITING FOR DOWNLOAD  ********************************/

  /************************* BTN ELIMINA NOTY CONFIRM ************************/

  $(document).on('click', '.btn_elimina', function () {

    var id = $(this).attr('data-id');
    var relationship_id = $(this).attr('data-relationship_id');
    var url = $(this).attr('data-url');
    var lang = $(this).attr('data-lang');
    var msg = $(this).attr('data-msg');
    var success_msg = $(this).attr('data-success_msg');
    var page_reload = $(this).attr('data-page_reload');
    var success_callback = $(this).attr('data-success_callback');

    var yes_button_text = 'Sì';
    var no_button_text = 'No';

    if (!lang || typeof lang == 'undefined') lang = 'it';

    if (lang != 'it') {
      yes_button_text = 'Yes';
      no_button_text = 'No';
    }

    if (!msg || typeof msg == 'undefined') {
      if (lang == 'it') {
        msg = "Sei sicuro di voler eliminare l'elemento selezionato?";
      } else {
        msg = "Are you sure you want to delete this element?";
      }
    }

    if (!success_msg || typeof success_msg == 'undefined') {
      if (lang == 'it') {
        success_msg = 'Elemento eliminato con successo';
      } else {
        success_msg = 'Element successfully deleted';
      }
    }

    if (!success_callback || typeof success_callback == 'undefined') success_callback = false;
    page_reload = page_reload || false;

    event.preventDefault();

    var ajax_function = function () {

      var waiting_noty = new Noty({
        type: 'info',
        layout: 'topRight',
        theme: 'bootstrap-v3',
        timeout: 5000,
        text: 'Attendere prego',
      }).show();

      $.ajax({
        url: url,
        type: 'POST',
        dataType: 'JSON',
        data: {
          id: id,
          relationship_id: relationship_id
        },
      })
        .done(function (response) {
          if (response.message == 'OK') {
            noty_success(success_msg);
            if (success_callback && typeof window[success_callback] === 'function') {
              window[success_callback].call();
            } else if (page_reload) {
              window.location.reload();
            }
          } else {
            noty_warning(response.message);
          }
        })
        .fail(function (data) {
          gestione_errore_ajax(data);
        })
        .always(function () {
          waiting_noty.close();
        });
    }

    noty_confirm(msg, yes_button_text, no_button_text, ajax_function);
  });

  /************************* /BTN ELIMINA NOTY CONFIRM ************************/

  /*******************************  INIT PLUGINS  ********************************/

  /*******************************  TOOLTIP  ********************************/

  if ($('[data-toggle="tooltip"]').length) {
    for (var i = 0; i < $('[data-toggle="tooltip"]').length; i++) {
      apply_tooltip($('[data-toggle="tooltip"]').eq(i));
    }
  }

  /*******************************  /TOOLTIP  ********************************/

  /*******************************  POPOVER  ********************************/

  if ($('[data-toggle="popover"]').length) {
    for (var i = 0; i < $('[data-toggle="popover"]').length; i++) {
      apply_popover($('[data-toggle="popover"]').eq(i));
    }
  }

  /*******************************  /POPOVER  ********************************/

  /*******************************  POPOVER  ********************************/

  if ($('.datatable').length) {
    for (var i = 0; i < $('.datatable').length; i++) {
      apply_datatable($('.datatable').eq(i));
    }
  }

  /*******************************  /POPOVER  ********************************/

  /*******************************  FILE INPUTS  ********************************/

  if ($('.file_upload_area').length) {
    for (var i = 0; i < $('.file_upload_area').length; i++) {
      apply_fileinput($('.file_upload_area').eq(i));
    }
  }

  $(document).on('filebatchselected', '.file_upload_area', function (event, file, previewId, index) {
    var direct_upload = $(this).attr('data-direct_upload');
    if (direct_upload == 'true') {
      direct_upload = true;
    } else {
      direct_upload = false;
    }
    if (direct_upload) {
      $(this).fileinput('upload');
    }
  });

  $(document).on('filebatchuploadcomplete', '.file_upload_area', function (event, data, previewId, index) {
    var success_callback = $(this).attr('data-success_callback');
    var page_reload = parseInt($(this).attr('data-page_reload'));
    if (isNaN(page_reload)) page_reload = 0;
    if (typeof success_callback == 'undefined' || success_callback == '') success_callback = false;

    if (page_reload === 1) {
      window.location.reload();
    }
    if (success_callback && typeof window[success_callback] === 'function') {
      window[success_callback].call();
    }
  });

  $(document).on('fileuploaderror', '.file_upload_area', function (event, data) {
    gestione_errore_ajax(data.jqXHR);
    var error_callback = $(this).attr('data-error_callback');
    if (typeof error_callback == 'undefined' || error_callback == '') error_callback = false;
    if (error_callback && typeof window[error_callback] === 'function') {
      window[error_callback].call();
    }
  });

  /*******************************  /FILE INPUTS  ********************************/

  /*******************************  AJAX SELECT2  ********************************/

  if ($('.ajax_select').length) {
    for (var i = 0; i < $('.ajax_select').length; i++) {
      ajax_select($('.ajax_select').eq(i));
    }
  }

  /*******************************  /AJAX SELECT2  ********************************/

  /*******************************  SELECT2  ********************************/

  if ($('.enhanced_select').length) {
    for (var i = 0; i < $('.enhanced_select').length; i++) {
      enhanced_select($('.enhanced_select').eq(i));
    }
  }

  /*******************************  /SELECT2  ********************************/

  /*******************************  TAG SELECT  ********************************/

  if ($('.tag_select').length) {
    for (var i = 0; i < $('.tag_select').length; i++) {
      tag_select($('.tag_select').eq(i));
    }
  }

  /*******************************  /TAG SELECT  ********************************/

  /*******************************  DATEPICKER  ********************************/

  if ($('.datepicker').length) {
    for (var i = 0; i < $('.datepicker').length; i++) {
      apply_datepicker($('.datepicker').eq(i));
    }
  }

  /*******************************  /DATEPICKER  ********************************/

  /*******************************  MONTHPICKER  ********************************/

  if ($('.monthpicker').length) {
    for (var i = 0; i < $('.monthpicker').length; i++) {
      apply_monthpicker($('.monthpicker').eq(i));
    }
  }

  /*******************************  /MONTHPICKER  ********************************/

  /*******************************  DATETIMEPICKER  ********************************/

  if ($('.datetimepicker').length) {
    for (var i = 0; i < $('.datetimepicker').length; i++) {
      apply_datetimepicker($('.datetimepicker').eq(i));
    }
  }

  /*******************************  /DATETIMEPICKER  ********************************/

  /*******************************  MULTIDATEPICKER  ********************************/

  if ($('.multidatespicker').length) {
    for (var i = 0; i < $('.multidatespicker').length; i++) {
      apply_multidatespicker($('.multidatespicker').eq(i));
    }
  }

  /*******************************  /MULTIDATEPICKER  ********************************/

  /*******************************  DATERANGEPICKER  ********************************/

  if ($('.daterange').length) {
    for (var i = 0; i < $('.daterange').length; i++) {
      apply_daterange($('.daterange').eq(i));
    }
  }

  /*******************************  /DATERANGEPICKER  ********************************/

  /*******************************  TEXT EDITOR  ********************************/

  if ($('.text_editor').length) {
    for (var i = 0; i < $('.text_editor').length; i++) {
      apply_text_editor($('.text_editor').eq(i));
    }
  }

  /*******************************  /TEXT EDITOR  ********************************/

  /*******************************  /INIT PLUGINS  ********************************/

});

$(window).on('load', function () {

  /*******************************  LOADER  ********************************/

  if ($('#page_loader').length) {
    $('#page_loader').remove();
  }

  /*******************************  /LOADER  ********************************/

  /*******************************  IMAGE LAZY LOADING  ********************************/

  for (var i = 0; i < $('img').length; i++) {
    img_lazy_load($('img').eq(i));
  }

  /*******************************  /IMAGE LAZY LOADING  ********************************/

  /*******************************  SWITCH TOGGLE PROPERTY  ********************************/

  $(document).on('change', '.switch_toggle_property', function (event) {

    var $switch = $(this);
    var url = $(this).attr('data-url');
    var value = $(this).prop('checked');
    var property = $(this).attr('data-property');
    var id = $(this).attr('data-id');
    var confirm = parseInt($(this).attr('data-confirm'));
    var confirm_msg = $(this).attr('data-confirm_msg');

    if (typeof confirm_msg == 'undefined' || confirm_msg == '') {
      confirm_msg = 'Sei sicuro di voler procedere?';
    }

    event.preventDefault();

    var ajax_call = function () {

      var waiting_noty = new Noty({
        type: 'info',
        layout: 'topRight',
        theme: 'bootstrap-v3',
        timeout: 5000,
        text: 'Attendere prego',
      }).show();

      $.ajax({
        url: url,
        type: 'POST',
        dataType: 'JSON',
        data: {
          id: id,
          property: property,
          value: value
        },
      })
        .done(function (response) {
          if (response.message == 'OK') {
            noty_success('Operazione conclusa con successo');
          } else {
            noty_warning(response.message);
          }
        })
        .fail(function (data) {
          gestione_errore_ajax(data);
          if (value) {
            $switch.prop('checked', false);
          } else {
            $switch.prop('checked', true);
          }
        })
        .always(function () {
          waiting_noty.close();
        });
    }

    if (confirm === 1) {
      noty_confirm(confirm_msg, 'Sì', 'No', ajax_call, function () {
        if (value) {
          $switch.prop('checked', false);
        } else {
          $switch.prop('checked', true);
        }
      });
    } else {
      ajax_call();
    }

  });

  /*******************************  /SWITCH TOGGLE PROPERTY  ********************************/

});

function img_lazy_load($img) {
  var data_src = $img.attr('data-src');
  if (typeof data_src == 'undefined' || data_src == '') return false;
  $img.attr('src', data_src);
}

function apply_cubeportfolio($element) {
  var filters_container = $element.attr('data-filters_container');
  $element.cubeportfolio({
    filters: filters_container,
    mediaQueries: [
      {width: 1000, cols: 3},
      {width: 600, cols: 2},
      {width: 320, cols: 1},
    ]
  });
}

function ajax_select($element) {
  var ajax_select_url = $element.attr('data-url');
  $element.select2({
    language: "it",
    ajax: {
      url: ajax_select_url,
      type: 'post',
      dataType: 'json',
      delay: 300,
      data: function (params) {
        var query = {
          cerca: params.term,
        }
        return query;
      },
      processResults: function (data) {
        return {
          results: data
        };
      }
    }
  });
}

function apply_fileinput($element) {

  var url = $element.attr('data-url');
  var main_class = $element.attr('data-main_class');
  var show_caption = $element.attr('data-show_caption');
  var show_browse = $element.attr('data-show_browse');
  var browse_on_click = $element.attr('data-browse_on_click');
  var extra_data = $element.attr('data-extra_data');
  var lang = $element.attr('data-lang');

  if (extra_data && extra_data != '') extra_data = JSON.parse(extra_data);
  if (!lang || lang == '') lang = 'it';

  var upload_extra_data = function (previewId, index) {
    return {};
  }

  if (typeof main_class == 'undefined' || main_class == '') main_class = false;

  if (typeof extra_data == 'object') {
    upload_extra_data = function (previewId, index) {
      return extra_data;
    }
  }

  if (show_caption == 'true') {
    show_caption = true;
  } else {
    show_caption = false;
  }
  if (show_browse == 'true') {
    show_browse = true;
  } else {
    show_browse = false;
  }
  if (browse_on_click == 'true') {
    browse_on_click = true;
  } else {
    browse_on_click = false;
  }

  $element.fileinput({
    maxFilePreviewSize: 65536,
    uploadUrl: url,
    uploadExtraData: upload_extra_data,
    language: lang,
    theme: 'fas',
    showCaption: show_caption,
    showBrowse: show_browse,
    showUpload: false,
    showCancel: false,
    showRemove: false,
    browseOnZoneClick: browse_on_click,
    layoutTemplates: {
      actions: '<div class="file-actions">\n' +
        '    <div class="file-footer-buttons">\n' +
        '        {delete}' +
        '    </div>\n' +
        '    <div class="clearfix"></div>\n' +
        '</div>',
    },
  });

  if (main_class) {
    $element.prev('.file-input').addClass(main_class);
  }
}

function enhanced_select($element) {

  var lang = $element.attr('data-lang');

  var options = {
    enableFiltering: true,
    enableCaseInsensitiveFiltering: true,
    enableCollapsibleOptGroups: true,
    enableClickableOptGroups: true,
    includeSelectAllOption: true,
    numberDisplayed: 1,
    buttonWidth: '100%',
    templates: {
      filter: '<li class="multiselect-item filter px-3"><div class="input-group"><div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-search"></i></span></div><input class="form-control multiselect-search" type="text"></div></li>',
      filterClearBtn: '<div class="input-group-append"><button class="btn btn-secondary multiselect-clear-filter" type="button"><i class="fas fa-times"></i></button></div>',
    }
  };

  if (!lang || lang == '') lang = 'it';

  if (lang == 'it') {
    options['nonSelectedText'] = 'Seleziona una opzione';
    options['selectAllText'] = 'Seleziona tutti';
    options['nSelectedText'] = ' selezionati';
    options['filterPlaceholder'] = 'Cerca';
    options['allSelectedText'] = 'Tutti';
  }

  $element.multiselect(options);
}

function tag_select($element) {
  $element.select2({
    tags: true,
    tokenSeparators: [',', ' ']
  })
}

function display_relationships(elements, $relationship_container) {
  $.each(elements, function (index, element) {
    var relationship = '<div class="col-md-12 col_relationship mb-3">';
    relationship += '<div class="relationship" data-relationship_id="' + element.relationship_id + '">';
    relationship += element.nome;
    relationship += '<button type="button" class="float-right btn btn-danger btn-sm btn_unlink_relationship"'
    relationship += 'data-action="' + element.remove_action + '"';
    relationship += 'data-this_id="' + element.this_id + '"';
    relationship += 'data-relationship_id="' + element.relationship_id + '">';
    relationship += '<i class="fas fa-times"></i>';
    relationship += '</button>';
    relationship += '</div>';
    relationship += '</div>';
    $relationship_container.append(relationship);
    disable_relatioship_option($relationship_container.closest('.form_link_relationship').find('.select_relationship'), element.relationship_id);
  });
}

function disable_relatioship_option($element, relationship_id, empty_select) {
  empty_select = empty_select || true;
  if (empty_select) {
    $element.val('');
  }
  $element.find('option[value="' + relationship_id + '"]').prop('disabled', true);
}

function enable_relatioship_option($element, relationship_id) {
  $element.find('option[value="' + relationship_id + '"]').prop('disabled', false);
}

function gestione_errore_ajax(data) {

  var response;
  var original_response;
  var show_ticket_form = false;

  if (typeof data == 'object' && 'responseJSON' in data) {
    response = data.responseJSON;
  } else {
    response = data;
  }

  original_response = response;

  if (typeof response == 'object') {
    var errors = '';
    if ('errors' in response) {
      $.each(response.errors, function (index, msg_errore) {
        errors += '<p>' + msg_errore + '</p>';
      });
    } else if ('message' in response) {
      errors = response.message;
      if ('exception' in response) {
        show_ticket_form = true;
      }
    } else if ('responseText' in response) {
      errors = response.responseText;
    }

    if (show_ticket_form == true) {
      errors += '<p></p>';
      errors += '<p>Se desideri, puoi segnalare l\'anomalia al servizio di assistenza tramite il pulsante sottostante.</p>';
      errors += '<div class="text-center">';
      errors += '<form action="/supporto/send_ticket" method="post" class="ajax_form">';
      errors += '<input type="hidden" name="response" value="' + encodeURIComponent(JSON.stringify(original_response)) + '">';
      errors += '<button type="submit" class="btn btn-success">';
      errors += 'Crea ticket';
      errors += '</button>';
      errors += '</form>';
      errors += '</div>';
    }

    response = errors;
  }

  noty_error(response, 15000);
}

var datetimepicker_icons = {
  time: 'fas fa-clock',
  date: 'fas fa-calendar-alt',
  up: 'fas fa-angle-up',
  down: 'fas fa-angle-down',
  previous: 'fas fa-angle-left',
  next: 'fas fa-angle-right',
  today: 'fas fa-calendar',
  clear: 'fas fa-sync-alt',
  close: 'fas fa-times'
};

function apply_datepicker($element) {

  $element.attr('autocomplete', 'off');

  if ($element.hasClass('multidatespicker')) {
    $element.multiDatesPicker('destroy');
  }

  var min_date = $element.attr('data-min_date');
  var max_date = $element.attr('data-max_date');

  if (typeof min_date == 'undefined' || min_date == '') {
    min_date = false;
  } else {
    min_date = new Date(min_date);
  }
  if (typeof max_date == 'undefined' || max_date == '') {
    max_date = false;
  } else {
    max_date = new Date(max_date);
  }

  $element.datetimepicker({
    format: 'DD/MM/YYYY',
    locale: 'it',
    icons: datetimepicker_icons,
    minDate: min_date,
    maxDate: max_date,
  });
}

function bind_start_end_dates($start_date_selector, $end_date_selector, maintain_null) {
  $(document).on('dp.change', $start_date_selector, function (event) {
    var data = $(this).val();
    var min_date = '';
    if (data != '') {
      min_date = moment(data, 'DD/MM/YYYY').toDate();
    }
    $($end_date_selector).attr('data-min_date', min_date);
    $($end_date_selector).data('DateTimePicker').destroy();
    apply_datepicker($($end_date_selector));
    if (maintain_null) {
      $($end_date_selector).val('');
    }
  });
  $($start_date_selector).trigger('dp.change');
}

function get_coordinates($address_input) {

  var address = $address_input.val();
  var $form = $address_input.closest('form');

  if (!address) {
    noty_warning('Inserire un indirizzo');
    return false;
  }

  formatted_address = encodeURIComponent(address);

  var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + formatted_address + ',+CA&key=AIzaSyBV55eBKKFIalgXvJ6IrMC_iTv-tdk8Q8E';

  $('#modal_coordinate_content').html('');
  $('#modal_coordinate_loader').show();
  $('#modal_coordinate').modal('show');

  $.ajax({
    headers: false,
    url: url,
    type: 'GET',
  })
    .done(function (addresses) {
      var addresses_list = '';
      if (addresses.results.length) {
        $.each(addresses.results, function (index, address) {
          var longitude = address.geometry.location.lng;
          var latitude = address.geometry.location.lat;
          addresses_list += '<a href="#" class="list-group-item coordinate_indirizzo" data-form_id="' + $form.attr('id') + '" data-longitudine="' + longitude + '" data-latitudine="' + latitude + '">';
          addresses_list += '<i class="fas fa-map-marker-alt"></i> ';
          addresses_list += address.formatted_address;
          addresses_list += '</a>';
        });
      } else {
        addresses_list += '<div class="col-sm-12">Nessuna corrispondenza trovata</div>';
      }
      $('#modal_coordinate_content').html(addresses_list);
    })
    .fail(function (data) {
      noty_error(data.responseText);
    })
    .always(function () {
      $('#modal_coordinate_loader').hide();
    });

}

function apply_monthpicker($element) {
  $element.datetimepicker({
    format: "MM/YYYY",
    viewMode: "years",
    locale: 'it'
  });
}

function apply_datetimepicker($element) {

  $element.attr('autocomplete', 'off');

  if ($element.hasClass('multidatespicker')) {
    $element.multiDatesPicker('destroy');
  }

  var min_date = $element.attr('data-min_date');
  var max_date = $element.attr('data-max_date');

  if (typeof min_date == 'undefined' || min_date == '') {
    min_date = false;
  } else {
    min_date = new Date(min_date);
  }
  if (typeof max_date == 'undefined' || max_date == '') {
    max_date = false;
  } else {
    max_date = new Date(max_date);
  }

  $element.datetimepicker({
    format: 'DD/MM/YYYY HH:mm',
    locale: 'it',
    icons: datetimepicker_icons,
    sideBySide: true,
    minDate: min_date,
    maxDate: max_date,
  });
}

function apply_multidatespicker($element) {

  if ($element.hasClass('datepicker') || $element.hasClass('datetimepicker')) {
    $element.data("DateTimePicker").destroy();
  }

  /*var min_date = $element.attr('data-min_date');
  var max_date = $element.attr('data-max_date');

  if (typeof min_date == 'undefined' || min_date == '') {
    min_date = false;
  } else {
    min_date = new Date(min_date);
  }
  if (typeof max_date == 'undefined' || max_date == '') {
    max_date = false;
  } else {
    max_date = new Date(max_date);
  }*/

  $element.multiDatesPicker({
    dateFormat: "dd/mm/yy",
    dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    dayNamesMin: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
  });
}

function top_bottom_scroll_bar($element) {
  $('.table-scroll-top div').css('width', $element.css('width'));
  $(function () {
    $(".table-scroll-top").scroll(function () {
      $(".table-scroll-bottom").scrollLeft($(".table-scroll-top").scrollLeft());
    });
    $(".table-scroll-bottom").scroll(function () {
      $(".table-scroll-top").scrollLeft($(".table-scroll-bottom").scrollLeft());
    });
  });
}

function apply_text_editor($element) {

  var height = parseInt($element.attr('data-height'));
  var max_height = parseInt($element.attr('data-max_height'));

  if (isNaN(height) || height <= 0) height = 200;
  if (isNaN(max_height) || max_height <= 0) max_height = null;

  $element.summernote({
    height: height,
    maxHeight: max_height,
    lang: 'it-IT',
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['misc', ['undo', 'redo']],
    ]
  });
}

function apply_table_fixed_header($element) {

  var $table = $($(this).attr('data-table'));

  if ($table.length <= 0) $table = $('table:first');

  var table_offset = $table.offset().top;
  var $fixed_head = $table.find('thead').clone();

  $element.append($fixed_head);

  resize_fixed_table_header();

  $(window).bind("scroll", function () {
    var offset = $(this).scrollTop();

    if (offset >= table_offset && $element.is(":hidden")) {
      $element.show();
    } else if (offset < table_offset) {
      $element.hide();
    }
  });
}

function resize_fixed_table_header() {
  if ($('.table_fixed_header').length) {
    for (var i = 0; i < $('.table_fixed_header').length; i++) {

      var $fixed_element = $('.table_fixed_header').eq(i);
      var $table = $($fixed_element.attr('data-table'));

      if ($table.length <= 0) $table = $('table:first');

      var $table_head = $table.find('thead');
      var $fixed_head = $fixed_element.find('thead');
      var table_width = $table.width();

      $fixed_element.css('width', table_width + 'px');

      $fixed_head.find('th').each(function (index) {
        var $original_th = $table_head.find('th').eq(index);
        if (!$original_th) return;
        $(this).attr('width', $original_th.width() + 'px');
      });
    }
  }
}

function apply_daterange($element) {

  $element.attr('autocomplete', 'off');

  var start_date = $element.attr('data-start_date');
  var end_date = $element.attr('data-end_date');
  var min_date = $element.attr('data-min_date');
  var max_date = $element.attr('data-max_date');
  var date_limit = $element.attr('data-date_limit');
  var show_ranges = $element.attr('data-show_ranges');
  var lang = $element.attr('data-lang');
  var ranges = {};
  var default_value = $element.val();
  var options = {};

  var last_week = [moment().subtract(7, 'days'), moment()];
  var last_15_days = [moment().subtract(15, 'days'), moment()];
  var last_month = [moment().subtract(1, 'months'), moment()];
  var last_2_months = [moment().subtract(2, 'months'), moment()];
  var last_6_months = [moment().subtract(6, 'months'), moment()];
  var last_year = [moment().subtract(1, 'year'), moment()];

  if (typeof start_date == 'undefined' || start_date == '') start_date = false;
  if (typeof end_date == 'undefined' || end_date == '') end_date = false;
  if (typeof min_date == 'undefined' || min_date == '') min_date = false;
  if (typeof max_date == 'undefined' || max_date == '') max_date = false;
  if (typeof date_limit == 'undefined' || date_limit == '') date_limit = false;
  if (typeof show_ranges == 'undefined' || show_ranges == '') show_ranges = true;
  if (typeof default_value == 'undefined' || default_value == '') default_value = false;
  if (typeof lang == 'undefined' || lang == '') lang = 'it';

  if (show_ranges) {
    if (lang == 'it') {
      ranges = {
        'Ultima settimana': last_week,
        'Ultimi 15 giorni': last_15_days,
        'Ultimo mese': last_month,
        'Ultimi 2 mesi': last_2_months,
        'Ultimi 6 mesi': last_6_months,
        'Ultimo anno': last_year
      };
    } else {
      ranges = {
        'Last week': last_week,
        'Last 15 days': last_15_days,
        'Last month': last_month,
        'Last 2 months': last_2_months,
        'Last 6 months': last_6_months,
        'Last year': last_year
      };
    }
  }

  options = {
    locale: {
      "format": "DD/MM/YYYY",
      "separator": " - ",
      "firstDay": 1
    },
    startDate: start_date,
    endDate: end_date,
    minDate: min_date,
    maxDate: max_date,
    dateLimit: date_limit,
    showCustomRangeLabel: false,
    alwaysShowCalendars: true,
    ranges: ranges
  };

  if (lang == 'it') {
    options["applyLabel"] = "Applica";
    options["cancelLabel"] = "Annulla";
    options["customRangeLabel"] = "Personalizzato";
    options["fromLabel"] = "Da";
    options["toLabel"] = "A";
    options["daysOfWeek"] = [
      "Dom",
      "Lun",
      "Mar",
      "Mer",
      "Gio",
      "Ven",
      "Sab"
    ];
    options["monthNames"] = [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ];
  }

  $element.daterangepicker(options);

  if (!start_date && !end_date && !default_value) {
    $element.val('');
  }
}

function apply_datatable($element) {

  var orderable = true;
  var datatable_dom = '';
  var lang = $element.attr('data-lang');
  var language_options = {};

  if (!lang || lang == '') lang = 'it';

  if (lang == 'it') {
    language_options = {
      "emptyTable": "Nessun dato disponibile",
      "info": "Record da _START_ a _END_ di _TOTAL_",
      "infoEmpty": "0 record",
      "infoFiltered": "(da un totale di _MAX_)",
      "lengthMenu": "Mostra _MENU_ record",
      "loadingRecords": "Caricamento...",
      "processing": "Caricamento...",
      "search": "Cerca ",
      "zeroRecords": "Nessun record corrispondente",
      "paginate": {
        "first": "Inizio",
        "last": "Fine",
        "next": "Successiva",
        "previous": "Precedente"
      },
      "aria": {
        "sortAscending": ": ordine crescente",
        "sortDescending": ": ordine decrescente"
      }
    };
  }

  datatable_dom += '<"row"';
  datatable_dom += '<"col-sm-6"l>';
  datatable_dom += '<"col-sm-6 text-right"f>';
  datatable_dom += '<"col-sm-6"i>';
  datatable_dom += '<"col-sm-6 text-right"p>';
  datatable_dom += '>';
  datatable_dom += 't';
  datatable_dom += '<"row"<"col-sm-6"i><"col-sm-6 text-right"p>>';

  $element.DataTable({
    dom: datatable_dom,
    responsive: true,
    aaSorting: [],
    language: language_options,
    columnDefs:
      [
        {targets: 'unorderable', orderable: false},
      ],
    lengthMenu:
      [[10, 30, 50, -1], [10, 30, 50, "Tutti"]],
    pageLength:
      30,
    ordering:
    orderable,
  });

  $element.find('.order-desc').trigger('click');
}

function apply_tooltip($element) {
  $element.tooltip();
}

function apply_popover($element) {
  $element.popover();
}

function close_all_noty() {
  $.noty.closeAll();
}

function apply_loader($element) {
  var height = parseInt($element.height());
  $element.html('<div class="text-center" style="height: ' + height + 'px"><i class="align-middle fas fa-circle-notch fa-spin fa-4x" style="position: relative; top: 45%;"></i></div>');
}